import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { FirmSelectors } from '../core/state/firm/firm.selectors';
import { Country } from '../core/entity/locale';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  template: '<iframe [src]="iframeUrl$ | async" width="100%" scrolling="yes" class="h-full"></iframe>',
  host: { class: 'h-full' },
})
export class StartIframeComponent {
  iframeUrl$: Observable<SafeUrl>;

  private urlsByCountryCode = {
    [Country.SE]: environment.startPageUrl.SE,
    [Country.NL]: environment.startPageUrl.NL,
  };

  constructor() {
    const sanitizer = inject(DomSanitizer);

    this.iframeUrl$ = inject(Store)
      .select(FirmSelectors.selectCountryCode)
      .pipe(
        map((countryCode) => this.getIframeUrlByCountryCode(countryCode)),
        map((url) => sanitizer.bypassSecurityTrustResourceUrl(url)),
      );
  }

  private getIframeUrlByCountryCode(countryCode: string): string {
    return this.urlsByCountryCode[countryCode] || this.urlsByCountryCode[Country.SE];
  }
}
